{
	"title": "Records",
	"subtitle": "The record book of {{games}}, and the records set at these games.",
	"tabs": {
		"label": "Records view",
		"book": "Record book",
		"marks": "Set at these games"
	},
	"type": {
		"WR": "World record",
		"OR": "Olympic record",
		"PR": "Paralympic record",
		"AR": "Asian record",
		"GR": "Games record",
		"NR": "National record"
	},
	"status": {
		"active": "Active",
		"inactive": "Inactive"
	},
	"filters": {
		"label": "Filter records",
		"search": "Search",
		"sport": "Sport",
		"allSports": "All sports",
		"discipline": "Discipline",
		"allDisciplines": "All disciplines",
		"event": "Event",
		"allEvents": "All events",
		"pickSportFirst": "Pick a sport first",
		"type": "Record type",
		"anyType": "Any type",
		"status": "Status",
		"anyStatus": "Active and inactive"
	},
	"actions": {
		"add": "Add record"
	},
	"table": {
		"event": "Event",
		"type": "Type",
		"mark": "Record",
		"holder": "Holder",
		"set": "Set",
		"status": "Status",
		"external": "Not in these games",
		"noDate": "No date",
		"count_one": "{{n}} record",
		"count_other": "{{n}} records",
		"edit": "Edit the record of {{name}}",
		"delete": "Delete the record of {{name}}"
	},
	"empty": {
		"noGamesTitle": "No games yet",
		"noGamesBody": "Records belong to a games. Once a games is set up in GMS, its record book shows here.",
		"noneTitle": "No records for {{games}} yet",
		"noneBody": "Records added by the competition setup team will show here.",
		"noneBodyWriter": "Add the records each event is measured against: world, Asian, Games and national records.",
		"filteredTitle": "No records match these filters",
		"filteredBody": "Try fewer filters, or another sport.",
		"reset": "Reset filters"
	},
	"errors": {
		"gamesTitle": "Couldn't load the games"
	},
	"form": {
		"addTitle": "Add record",
		"addSubtitle": "A record of an event of these games, or of an event they do not run.",
		"editTitle": "Edit record",
		"editSubtitle": "Change the record's holder, mark and details.",
		"filedUnder": "Event",
		"filedFixed": "Where a record is filed cannot change. To move it, delete it and add it again.",
		"external": "Event not in these games",
		"sport": "Sport",
		"pickSport": "Pick a sport",
		"discipline": "Discipline",
		"anyDiscipline": "Any discipline",
		"event": "Event",
		"pickEvent": "Pick an event",
		"label": "Event name",
		"labelHint": "As the record book names it, e.g. Men's 50m Butterfly.",
		"type": "Record type",
		"pickType": "Pick a type",
		"mark": "Record",
		"markHint": "As it is quoted: 9.58, 2:01.34, 8.45 m.",
		"holder": "Holder",
		"holderHint": "For a relay or a team, every name, separated by /.",
		"noc": "Holder's NOC",
		"nocHint": "A code or a country: MAS, Thailand.",
		"setOn": "Date set",
		"competition": "Competition",
		"venue": "Venue",
		"note": "Note",
		"active": "Active record",
		"required": "Required",
		"add": "Add record",
		"added": "Record added",
		"saved": "Record saved",
		"stale": "Someone else changed this record while you were editing it. Close this panel and open the record again to see their version."
	},
	"delete": {
		"title": "Delete this record?",
		"body": "The {{type}} of {{holder}} in {{event}} will be removed from the record book.",
		"confirm": "Delete record",
		"done": "Record deleted"
	},
	"marks": {
		"event": "Event",
		"competitor": "Competitor",
		"result": "Result",
		"rank": "Rank {{rank}}",
		"marks": "Records",
		"meet": "Meet",
		"count_one": "{{n}} result set a record",
		"count_other": "{{n}} results set a record",
		"emptyTitle": "No records set yet",
		"emptyBody": "When a meet screen marks a result as a record (GR, NR…), it shows here so the record book can be updated."
	}
}
